import {
	withProjectCardStyle,
} from 'root/src/client/web/list/listItemComponents/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classnames from 'classnames'

export const DareCardTypeIcon = withProjectCardStyle(({ classes, icon, ...props }) => (
	<div className={classnames(classes.circleBorder, classes.bgBlack)}>
		<FontAwesomeIcon size="lg" icon={icon} {...props} />
	</div>
))

export const ProjectCardCircleImage = withProjectCardStyle(({ classes, alt, ...props }) => (
	<div className={classes.circleBorder}>
		<img
			className={classes.circleImage}
			alt={alt}
			{...props}
		/>
	</div>
))
